<template>
  <div class="service-rain-alarm">
    <alarm-status
      :alarm="alarm"
      :alarm-active="computedAlarmIsActive"
    />

    <!-- <alert-handler-list
      class="g-alarm-handler__row"
      :list="alarmData.list"
    /> -->

    <hr>

    <!-- <div class="g-alarm-handler__row">
      <h3>{{ $t('messages.alarms.suggestion') }}</h3>
      <p>
        {{ $t('messages.alarms.serviceRainAlarm.suggestion') }}
      </p>
    </div> -->
  </div>
</template>

<script>
import {ServiceAlarm} from '@/assets/javascript/mixins/ServiceAlarm'

export default {
  name: 'ServiceRainAlarm',
  mixins: [ServiceAlarm]
}
</script>
